import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  CreateUpdateJobPositionDto,
  CreateUpdateJobPositionDtoFromJSON,
  GetJobPositionDto,
} from '../autogenerated/spdApiClient';
import { jobPositionForGrid } from '../../../spd/components/JobPosition/JobPositionSearch';

export interface JobPositionContextInterface {
  get: (id: string) => Promise<GetJobPositionDto>;
  getAll: () => Promise<GetJobPositionDto[]>;
  getAllForSelector: (
    text: string,
  ) => Promise<{ label: string; value: string }[]>;
  getAllCount: (filterText?: string) => Promise<number>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => Promise<GridRecord[]>;
  update: (id: string, dto: CreateUpdateJobPositionDto) => Promise<void>;
  create: (dto: CreateUpdateJobPositionDto) => Promise<GetJobPositionDto>;
}

export const JobPositionContext = (api: DefaultApi) => {
  return {
    get: async (id: string) => {
      return await api.jobPositionControllerGet(id);
    },

    getAll: () => api.jobPositionControllerGetAll(),
    getAllForSelector: async (text: string) => {
      const data = await api.jobPositionControllerGetAllByName(text);

      return Array.from(data, jobPosition => {
        return {
          value: jobPosition.id,
          label: jobPosition.name || '',
        };
      });
    },

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) => {
      const data = await api.jobPositionControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(jobPositionForGrid);
    },

    getAllCount: (filterText?: string) =>
      api.jobPositionControllerGetAllCount(filterText || ''),

    update: (id: string, dto: CreateUpdateJobPositionDto) =>
      api.jobPositionControllerUpdate(id, dto),

    create: (dto: CreateUpdateJobPositionDto) =>
      api.jobPositionControllerCreate(dto),
  };
};

// export const validate = (JobPosition: CreateUpdateJobPositionDto) => {
//   return validateAgainst(JobPositionSchema, JobPosition);
// };

export const JobPositionData = (
  jobPosition?: GetJobPositionDto,
): CreateUpdateJobPositionDto => {
  return CreateUpdateJobPositionDtoFromJSON({
    ...jobPosition,
    // healthcareFacilityId: jobPosition?.healthcareFacility?.id,
  });
};
